import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useTheme } from "../contexts/ThemeContext";

const Message = () => {
  const { mode } = useTheme();
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notification, setNotification] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setNotification(""); // Clear any previous notifications

    emailjs
      .sendForm("service_schhqml", "template_8rcs45c", form.current, {
        publicKey: "gBLDLO9MCSUYKrS7q",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          setNotification("Message sent successfully!");
          form.current.reset(); // Clear the form inputs
          setIsSubmitting(false);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setNotification("Failed to send message. Please try again.");
          setIsSubmitting(false);
        }
      );
  };

  return (
    <div className="mt-4 flex justify-center">
      <div
        className={`p-6 rounded-lg shadow-lg w-full max-w-md 
          ${
            mode === "light"
              ? "bg-white text-gray-900"
              : "bg-slate-800 text-white"
          }`}
      >
        <h1 className="text-xl font-bold">Drop a Message</h1>
        <form ref={form} onSubmit={sendEmail}>
          <input
            className={`w-full rounded-md mt-2 p-2 ${
              mode === "light"
                ? "bg-gray-200 text-black"
                : "bg-black text-white"
            } placeholder-gray-400`}
            type="text"
            placeholder="Your Name"
            name="your_name"
            required
          />
          <input
            className={`w-full rounded-md mt-2 p-2 ${
              mode === "light"
                ? "bg-gray-200 text-black"
                : "bg-black text-white"
            } placeholder-gray-400`}
            type="email"
            placeholder="you@example.com"
            name="your_email"
            required
          />
          <textarea
            className={`w-full rounded-md mt-2 h-20 p-2 ${
              mode === "light"
                ? "bg-gray-200 text-black"
                : "bg-black text-white"
            } placeholder-gray-400 resize-none`}
            placeholder="Hey, wassup?"
            name="message"
            required
          />
          <button
            className={`bg-indigo-600 text-white p-2 rounded-md mt-4 w-full 
              hover:bg-indigo-700 transition-colors 
              transform ${isSubmitting ? "scale-95" : ""}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send"}
          </button>
        </form>
        {notification && (
          <p className="mt-4 text-white text-sm">{notification}</p>
        )}
      </div>
    </div>
  );
};

export default Message;
